import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <div className='footer border-top'>
        <div className="details">
        <div className='text col-4'>
            <p className='heading'>Head Office</p>
            <p>Nabaki Afrika Holdings (Pty) Ltd</p>
            <p>Company Registration: 2020/020129/07</p>
            <p>CIBD Level: 4CE PE, 4GB PE</p>
            <p>345 Rivonia Road, Sandton, 2191</p>

        </div>
        <div className='text col-4 '>
            <p className='heading'>Request Consultation</p>
            <p>Phone: +27 79 850 1115</p>
            <p>Email: jimmy@nabaki.co.za</p>

        </div>
        <div className='text col-4'>
            <p className='heading'>Quick Links</p>
            <p><Link className="" to="/about">About Us</Link></p>
            <p><Link to='#' target='_blank'>Terms Of Service</Link></p>
            <p><Link className="" to="/contact">Contact Us</Link></p>
            {/* <p>FAQ</p> */}

        </div>
       
        </div>
        <div className="logo">
            <img src={'../assests/imgs/Logos/Logos/Cream Secondary Logo.png'} alt="" />
        </div>
    </div>
  )
}
